/** Controls how Composer handles a valid link click. */
export var LinkActivationType;
(function (LinkActivationType) {
    /** Prevent native navigation and leave activation to the optional observer. */
    LinkActivationType["CUSTOM"] = "custom";
    /** Open the link in a new tab without exposing the source window. */
    LinkActivationType["NEW_TAB"] = "newTab";
})(LinkActivationType || (LinkActivationType = {}));
//# sourceMappingURL=link.js.map